// UI helpers: grid toggle, qty adjuster, panels, passwords, address forms, scroll, reopen cart
// Provide safe stubs so inline handlers won't throw before initialization
window.adjustQty = window.adjustQty || function (delta) {
  if (window._ui && window._ui.adjustQty) return window._ui.adjustQty(delta);
};
window.setGrid = window.setGrid || function (cols) {
  if (window._ui && window._ui.setGrid) return window._ui.setGrid(cols);
};
window.togglePanel = window.togglePanel || function (showId, hideId) {
  if (window._ui && window._ui.togglePanel) return window._ui.togglePanel(showId, hideId);
};
window.togglePasswordVisibility = window.togglePasswordVisibility || function (inputId, btn) {
  if (window._ui && window._ui.togglePasswordVisibility) return window._ui.togglePasswordVisibility(inputId, btn);
};
window.toggleNewAddressForm = window.toggleNewAddressForm || function () {
  if (window._ui && window._ui.toggleNewAddressForm) return window._ui.toggleNewAddressForm();
};
window.toggleEditForm = window.toggleEditForm || function (id) {
  if (window._ui && window._ui.toggleEditForm) return window._ui.toggleEditForm(id);
};

document.addEventListener("DOMContentLoaded", function () {
  // store real implementations on window._ui so stubs can forward
  window._ui = window._ui || {};

  window._ui.adjustQty = function (delta) {
    const input = document.getElementById("qty-input");
    if (!input) return;
    const newVal = Math.max(1, parseInt(input.value || "1", 10) + delta);
    input.value = newVal;
  };

  window._ui.setGrid = function (cols) {
    const grid = document.getElementById("ProductGrid");
    if (!grid) return;
    if (cols === 2) {
      grid.className = grid.className
        .replace(/lg:grid-cols-\d+/, "lg:grid-cols-2")
        .replace(/md:grid-cols-\d+/, "md:grid-cols-2");
    } else {
      grid.className = grid.className
        .replace(/lg:grid-cols-\d+/, "lg:grid-cols-4")
        .replace(/md:grid-cols-\d+/, "md:grid-cols-3");
    }
  };

  window._ui.togglePanel = function (showId, hideId) {
    const show = document.getElementById(showId);
    const hide = document.getElementById(hideId);
    if (show) show.classList.remove("hidden");
    if (hide) hide.classList.add("hidden");
  };

  window._ui.togglePasswordVisibility = function (inputId, btn) {
    const input = document.getElementById(inputId);
    if (!input) return;
    input.type = input.type === "password" ? "text" : "password";
    if (btn) btn.style.opacity = input.type === "text" ? "1" : "0.5";
  };

  window.checkPasswordStrength = function (val, ctx) {
    const container =
      ctx && ctx.closest
        ? ctx.closest("section")
        : document.querySelector("section[data-strength-labels]");
    const bars = container
      ? container.querySelectorAll("[data-bar]")
      : document.querySelectorAll("[data-bar]");
    const label = container
      ? container.querySelector("#StrengthLabel")
      : document.getElementById("StrengthLabel");
    let score = 0;
    if (val.length >= 8) score++;
    if (/[A-Z]/.test(val)) score++;
    if (/[0-9]/.test(val)) score++;
    if (/[^A-Za-z0-9]/.test(val)) score++;
    const colors = ["#ef4444", "#f59e0b", "#3b82f6", "#22c55e"];
    let labels = ["Weak", "Fair", "Good", "Strong"];
    if (container && container.dataset && container.dataset.strengthLabels)
      labels = container.dataset.strengthLabels.split(",");
    bars.forEach((bar, i) => {
      bar.style.background =
        i < score ? colors[score - 1] : "var(--color-accent)";
    });
    if (label) {
      label.textContent = score > 0 ? labels[score - 1] : "";
      label.style.color = score > 0 ? colors[score - 1] : "";
    }
  };

  window.checkPasswordMatch = function () {
    const pw = document.getElementById("RegisterPassword");
    const confirm = document.getElementById("RegisterPasswordConfirm");
    const icon = document.getElementById("MatchIcon");
    const svg = document.getElementById("MatchIconSvg");
    if (!confirm) return;
    if (confirm.value.length > 0) {
      if (icon) icon.classList.remove("hidden");
      if (svg)
        svg.style.color =
          pw && pw.value === confirm.value
            ? "var(--color-success-text)"
            : "var(--color-error-text)";
    } else {
      if (icon) icon.classList.add("hidden");
    }
  };

  // Checkbox visual toggle for marketing opt-in
  const checkbox = document.getElementById("AcceptsMarketing");
  if (checkbox) {
    const visual = document.getElementById("CheckboxVisual");
    const check = document.getElementById("CheckboxCheck");
    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        if (visual) {
          visual.style.background = "var(--color-primary)";
        }
        if (check) {
          check.style.display = "block";
          check.style.color = "var(--color-button-text)";
        }
      } else {
        if (visual) visual.style.background = "";
        if (check) check.style.display = "none";
      }
    });
  }

  // Province/State dynamic selector via Shopify's address.js
  document.querySelectorAll('select[id$="_country"]').forEach((countryEl) => {
    const id = countryEl.id.replace(/_country$/, "");
    const provinceEl = document.getElementById(id + "_province");
    const provinceContainer = document.getElementById(
      id + "_province_container",
    );

    if (!provinceEl) return;

    if (window.Shopify && window.Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(countryEl.id, provinceEl.id, {
        hideElement: provinceContainer ? provinceContainer.id : undefined,
      });
    }
  });

  window._ui.toggleNewAddressForm = function () {
    const form = document.getElementById("NewAddressForm");
    if (!form) return;
    form.classList.toggle("hidden");
    const btn = document.getElementById("AddNewBtn");
    if (btn)
      btn.textContent = form.classList.contains("hidden")
        ? '{{ "customer.addresses.add_new" | t | escape }}'
        : '{{ "customer.addresses.cancel" | t | escape }}';
    if (!form.classList.contains("hidden"))
      form.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  window._ui.toggleEditForm = function (id) {
    const form = document.getElementById(id);
    if (!form) return;
    form.classList.toggle("hidden");
    if (!form.classList.contains("hidden"))
      form.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };

  // Scroll-to-top button
  const scrollBtn = document.getElementById("scroll-top");
  if (scrollBtn) {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 400) {
        scrollBtn.classList.remove("opacity-0", "pointer-events-none");
        scrollBtn.classList.add("opacity-100");
      } else {
        scrollBtn.classList.add("opacity-0", "pointer-events-none");
        scrollBtn.classList.remove("opacity-100");
      }
    });
    scrollBtn.addEventListener("click", () =>
      window.scrollTo({ top: 0, behavior: "smooth" }),
    );
  }

  // Re-open cart after reload if an update triggered a Cloudflare challenge
  try {
    if (sessionStorage.getItem("reopen_cart_after_reload") === "true") {
      sessionStorage.removeItem("reopen_cart_after_reload");
      setTimeout(() => {
        try {
          if (window.openCart) window.openCart();
        } catch (e) {}
      }, 200);
    }
  } catch (e) {}
});
